import { register, getPrefix, getCookie } from '../../../Utils'

const ContentPopup = el => {
  const prefix = getPrefix(el)
  const openers = document.querySelectorAll(`.${el.dataset.openerClass}`)
  const openOnInnerFormFeedback = el.dataset.formFeedback
  const closeButton = el.querySelector(`.${prefix}close-button`)
  const backdrop = el.querySelector(`.${prefix}backdrop`)

  // Check, if a form with specific ID inside the popup has a message and if yes, open the popup
  // Made comparison simpler since some messages don't include the form tag
  if (openOnInnerFormFeedback) {
    const innerForm = el.innerHTML
    const url = new URL(window.location.href)
    const urlHash = url.hash

    if (urlHash) {
      const urlId = urlHash.replace('#', '')

      if (innerForm.includes(urlId)) {
        el.classList.add(`${prefix}is--visible`)
      }
    }
  }

  // Open the Popup click event
  const openPopup = e => {
    e.preventDefault()

    el.classList.add(`${prefix}is--visible`)
  }

  // Close the Popup click event
  const closePopup = e => {
    e.preventDefault()

    el.classList.remove(`${prefix}is--visible`)
  }

  // Add event listeners for opening and closing
  openers.forEach(opener => opener.addEventListener('click', openPopup))
  closeButton.addEventListener('click', closePopup)
  backdrop.addEventListener('click', closePopup)
}

register('ContentPopup', ContentPopup)
